export const CONSULTATION_STATUSES = {
  NEW: 'new',
  CHECKING_MEDICAL_PROFILE: 'checking_medical_profile',
  IN_PROGRESS: 'in_progress',
  CLOSED: 'closed',
} as const


export const CONSULTATION_MEDIUMS = {
  chat: 'chat',
  gsm: 'gsm',
} as const
